import { FC } from 'react';

import * as S from './styled';

/**
 * Marks an archived bank account.
 *
 * A company can hold several accounts with the same name, and the client portal hides
 * the archived ones entirely — so in the backoffice the marker is often the only thing
 * telling two identically named accounts apart [ENG-1211].
 */
const ArchivedTag: FC = () => <S.Tag>Archived</S.Tag>;

export default ArchivedTag;
